import React, {PropTypes} from "react";
import {connect} from "react-redux";
import SearchTab from "./SearchTab";
import AttendanceTable from "./MyAttendanceTable";
import SearchForm from "./SearchForm";
import * as actions from "../../../redux/actions/Attendance/attendanceActions";

let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();
var default_search = {
  startDate: from,
  endDate: to,
  pageNo: 0
};
class MyAttendance extends React.Component {

  constructor() {
    super();
    this.state = {value: 1, flag: true, data: [], series: [], dates: default_search, totalHours: null};
    this.handleSelect = this.handleSelect.bind(this);
    this.form_submit = this.form_submit.bind(this);
    this.setCheckInTime = this.setCheckInTime.bind(this);
  }

  handleSelect(selectedKey) {
    if (selectedKey != this.state.value)
      this.setState({value: selectedKey, flag: !this.state.flag});
  }

  setCheckInTime(time) {
    this.setState({totalHours: time})
  }

  getChartData(attendance) {
    let data = new Array();
    let series = new Array();
    attendance.map((attendanceData, index)=> {
      data[index] = new Array();
      let hrs = 0, mins = 0;
        if(attendanceData.totalWorkingHour != null) {
          data[index][0] = attendanceData.totalWorkingHour.substr(0, 5);
          data[index][0] = data[index][0].replace(":", ".");
          data[index][0] = parseFloat(data[index][0]);
        } else {
          data[index][0] = 0;
        }
      if (attendanceData.date != null)
        series[index] = attendanceData.date.substr(0, 6);
    });


    this.setState({data: data, series: series});
  }

  form_submit(request) {
    this.props.dispatch(actions.getAttendance(request));
  }

  componentDidMount() {
    this.props.changeBanner("Attendance");
    if (this.props.state)
      if (this.props.state[0].attendance.empId != 0)
        this.getChartData(this.props.state[0].attendance.attendance);
  }

  componentWillReceiveProps(props) {
    this.getChartData(props.state[0].attendance.attendance);

  }

  render() {


    return (
      <div>
        <div >
          <div role="tabpanel" className="tab-pane" id="apply">
            <div className="row clearfix">
              <div className="col-md-12" style={{paddingLeft: 0}}>
                <div className="col-md-4">
                  <SearchForm dates={this.props.dates} change_date={this.props.change_date}
                              form_submit={this.form_submit}/>
                </div>
                {this.props.state[0].attendance.avgWorkHours != null ?
                  <SearchTab dates={this.props.dates} attendanceMain={this.props.state[0].attendance}
                             message={this.state.totalHours}/> :
                  <SearchTab dates={this.props.dates} attendanceMain={this.props.state[0].attendance} message={null}/>}

                <div
                  style={{
                    borderTopStyle: 'solid',
                    borderBottomStyle: 'solid',
                    borderWidth: '1px',
                    borderColor: 'rgb(92, 184, 92)',
                    paddingRight: 0,
                    paddingLeft: 0

                  }}
                  className="col-md-12">
                  <AttendanceTable
                    checkIn={this.setCheckInTime}
                    pageNo={this.props.myPageNo}
                    changePage={this.props.changePage}
                    data={this.state.data}
                    series={this.state.series}
                    attendance={this.props.state}/></div>
              </div>
            </div>
          </div>
        </div>
      </div>




    );
  }

}

MyAttendance.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state.attendance,
    loading: state.ajaxCallsInProgress
  };

}


export default connect(mapStateToProps)(MyAttendance);




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/MyAttendance.js
 **/